import { CUSTOM_ELEMENTS_SCHEMA, Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import * as _ from 'lodash';
import { catchError, finalize, forkJoin, map } from 'rxjs';

import { EInterventionStatus } from 'src/app/domain/enums/intervention-status';

import { Intervention } from 'src/app/domain/intervention';

import { MatButtonModule } from '@angular/material/button';
import { MatDialog } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleChange, MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar } from '@angular/material/snack-bar';
import { InterventionRepository } from 'src/app/db/repository/intervention.repository';
import { ENavigationRoute } from 'src/app/models/enums/navigation-route';
import { DocumentService } from 'src/app/services/document.service';
import { InterventionService } from 'src/app/services/intervention.service';
import { MasterDataService } from 'src/app/services/master-data.service';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { LoadingTask } from 'src/app/tools/loading-task';
import { ColorService } from 'src/app/tools/ui/color.service';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { EDocumentType } from 'src/app/tools/ui/mutilple-file-upload-box/document-type';
import { MultipleFileUploadBoxDialog } from 'src/app/tools/ui/mutilple-file-upload-box/multiple-file-upload-box';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { environment } from 'src/environments/environment';
import { db } from '../../db/db';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-intervention-list',
    templateUrl: './intervention-list.component.html',
    styleUrl: './intervention-list.component.scss',
    standalone: true,
    imports: [MatButtonModule, PreventDoubleClickDirective, MatIconModule, MatSlideToggleModule, FormsModule, MatInputModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class InterventionListComponent implements OnInit {
    EInterventionStatus = EInterventionStatus;
    InterventionList: Intervention[] = [];
    FilteredInterventionList?: Intervention[] = [];
    checked: boolean = true;
    SearchText: string = ''

    get IsDevelopment() {
        return environment.name === 'DEV';
    }
    get IsMobile() {
        return this.coreData.IsMobile;
    }

    constructor(
        private coreData: CoreData,
        private interventionService: InterventionService,
        private masterDataService: MasterDataService,
        private snackBar: MatSnackBar,
        private router: Router,
        public loadingTask: LoadingTask,
        private dialog: MatDialog,
        private documentService: DocumentService,
        private interventionRepository: InterventionRepository) { }

    async ngOnInit(): Promise<void> {

        this.coreData.CurrentPageName = "Mes Interventions";

        this.checked = this.coreData.WithDone

        if (!this.IsMobile) {
            this.getInterventionWithQualifSalleOnline();
            return;
        }

        await this.getInterventionListFromLocalDB();
        if (!this.checked)
            this.FilteredInterventionList = this.InterventionList = this.InterventionList.filter(x => x.Status !== EInterventionStatus.Done)
    }

    async change(event: MatSlideToggleChange) {
        this.loadingTask.activateLoading();
        this.checked = event.checked;
        if (event.checked) {
            await this.getInterventionListFromLocalDB()
        } else {
            this.InterventionList = this.InterventionList.filter(x => x.Status !== EInterventionStatus.Done)
        }
        this.coreData.WithDone = event.checked;
        this.loadingTask.deactivateLoading();
    }

    getColor() {
        return ColorService.getRandomPastelColor();
    }

    reset() {
        this.interventionService.getMyIntervention().subscribe(async x => {

            await db.resetDatabase();
            for (let i = 0, y: Intervention; y = x[i]; i++) {
                await this.interventionRepository.addIntervention(y);
            }
            await this.getInterventionListFromLocalDB();
        })
    }

    searchIntervention() {
        this.getInterventionWithQualifSalleOnline(this.SearchText)
    }

    async clearFilter() {
        this.loadingTask.activateLoading()
        this.SearchText = '';
        this.FilteredInterventionList = []
        this.loadingTask.deactivateLoading();
    }

    getMyIntervention(lastMinute?: boolean) {
        if (this.loadingTask.LoadingCount) {
            NotificationManager.handleSuccess('Merci de patienter !', this.snackBar);
            return;
        }
        const dialogRef = this.dialog.open(ConfirmBoxDialog, { data: { message: 'Etes-vous sûr de vouloir récupérer les nouvelles interventions ?', withCancelButton: true } });
        dialogRef.afterClosed().subscribe((result: boolean) => {
            if (result) {
                forkJoin([
                    lastMinute ? this.interventionService.getMyInterventionLastMinute() : this.interventionService.getMyIntervention(),

                ]).subscribe(async ([intList]) => {
                    this.loadingTask.activateLoading();
                    await this.getInterventionListFromLocalDB()

                    // Remove intervention that from the past days if they are done
                    for (let i = 0, int: Intervention; i < this.InterventionList.length; i++) {
                        int = this.InterventionList[i];
                        if (int.Status === EInterventionStatus.Preview || Temporal.PlainDate.compare(int.PlannedDate, (Temporal.Now.plainDateISO())) === -1) {
                            await this.interventionRepository.deleteIntervention(int.Code);
                        }
                    }

                    await this.getInterventionListFromLocalDB();
                    const diff: Intervention[] = _.differenceBy(intList, this.InterventionList, x => x.Code);
                    if (diff && diff.length > 0) {
                        for (let i = 0; i < diff.length; i++) {
                            await this.interventionRepository.addIntervention(diff[i]);
                        }
                    }
                    // _.remove(this.InterventionList, x => x.Code === int.Code);
                    await this.getInterventionListFromLocalDB();
                    this.loadingTask.deactivateLoading();
                    NotificationManager.handleSuccess('Récupération des interventions terminée !', this.snackBar);
                })
            }
        });
    }

    getInterventionWithQualifSalleOnline(filter?: string) {
        this.interventionService.getInterventionWithQualifSalleOnlyByFilter(filter).subscribe(x => {
            this.FilteredInterventionList = this.InterventionList = x;
        })
    }

    async getInterventionListFromLocalDB() {
        this.FilteredInterventionList = this.InterventionList = await this.interventionRepository.getInterventionList();
    }

    async getInterventionListFromMockedData() {

    }

    refreshSpecificIntervention(event: Event, int: Intervention) {
        event.preventDefault();
        event.stopPropagation();
        const dialogRef = this.dialog.open(ConfirmBoxDialog, { data: { message: 'Etes-vous sûr de vouloir recharger cette intervention, ce qui n\'est pas sauvegardé sera perdu', withCancelButton: true } });
        dialogRef.afterClosed().subscribe(async (result: boolean) => {
            if (result) {

                this.interventionService.geInterventionByCode(int.Code).subscribe(async (x: Intervention) => {
                    this.loadingTask.activateLoading();
                    await this.interventionRepository.deleteIntervention(int.Code);
                    await this.interventionRepository.addIntervention(x);
                    // await this.getInterventionListFromLocalDB();
                    this.loadingTask.deactivateLoading();
                    NotificationManager.handleSuccess('Intervention mise à jour', this.snackBar);
                });
            }
        })
    }

    async navigatoToIntervention(int: Intervention, samplingPointName: string) {
        if (this.loadingTask.LoadingCount > 0) {
            return;
        }

        if (int.Status === EInterventionStatus.Validated) {
            int.Status = EInterventionStatus.InProgress;
            await this.interventionRepository.changeInterventionStatus(int);
        }

        this.coreData.CurrentPageName = samplingPointName;
        this.router.navigate([ENavigationRoute.Intervention, { interventionCode: int.Code }])
    }

    navigateToPlan(int: Intervention) {
        this.router.navigate([ENavigationRoute.Plan, { interventionCode: int.Code }])
    }

    /** OSO COLOURS BLURP TO REMOVE ASAP */
    getColorByInterventionIndex(status: EInterventionStatus) {

        switch (status) {
            // case EInterventionStatus.New:
            //     return "red !important";
            case EInterventionStatus.Validated:
                return "red !important"
            case EInterventionStatus.InProgress:
                return "orange !important";
            case EInterventionStatus.Done:
                return "green !important";
            case EInterventionStatus.Canceled:
                return "black !important";
            case EInterventionStatus.Preview:
                return "blueviolet !important"
        }
        return "grey";
    }

    // async getStaticPumpWithBattery(code: number) {
    //     let int = await db.getInterventionByCode(code);
    //     return int.ZoneList.filter(x => x.ZoneMesureList.map(y => y.PumpWithBattery === true));
    // }

    // async getStaticPumpWithPowerSupply(code: number) {
    //     let int = await db.getInterventionByCode(code);
    //     return int.ZoneList.filter(x => x.ZoneMesureList.map(y => y.PumpWithBattery === false));
    // }

    // async getPumpOnOperator(code: number) {
    //     let int = await db.getInterventionByCode(code);
    //     return int.ProcessList.map(x => x.ProcessMesure.ProcessOperatorList.map(y => y.CassetteList.map(z => z.Pompe))).flat(2).length;
    // }

    // async setInterventionAsFinished(event: Event, int: Intervention) {
    //     event.preventDefault();
    //     event.stopPropagation();

    //     this.sync(int);
    // }

    openDocumentDialog() {
        const dialogRef = this.dialog.open(MultipleFileUploadBoxDialog, {
            data: { type: EDocumentType.Result },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe((result: string) => {
            if (result) { // result = file name

                NotificationManager.handleSuccess('Fichier(s) correctement ajouté(s)', this.snackBar)
            }
        });
    }

    async handleSync(code: string, event?: Event, withDoneHandler?: boolean) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }

        const int = await this.interventionRepository.getInterventionByCode(code);
        if (withDoneHandler) {
            const dialogRef = this.dialog.open(ConfirmBoxDialog, { data: { message: 'Etes-vous sûr d\'avoir terminé ce client ?', withCancelButton: true } });
            dialogRef.afterClosed().subscribe(async (result: boolean) => {
                if (result) {
                    int.Status = EInterventionStatus.Done;
                    this.sync(int, true)
                }
            })
            return;
        }
        this.sync(int);
    }

     sync(int: Intervention, withDoneHandler?: boolean) {

        this.interventionService.syncIntervention(int)
            .pipe(
                catchError((err: any) => {
                    if (withDoneHandler) {
                        int.Status = EInterventionStatus.Validated;
                    }
                    throw err
                    // return of(0);
                }),
                finalize(() => this.loadingTask.deactivateLoading()),
                map(x => x))
            .subscribe(
                async (x: any) => {
                    NotificationManager.handleSuccess('Intervention sauvegardée', this.snackBar);
                    if (withDoneHandler) {
                        await this.interventionRepository.changeInterventionStatus(int);
                    }
                });
    }
}
